import { render, staticRenderFns } from "./interviews.vue?vue&type=template&id=f525f9e8"
import script from "./interviews.vue?vue&type=script&lang=js"
export * from "./interviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports